import Layout from '@/page/layout/home'
import LayoutNoFooter from '@/page/layout/index'
import bizRouters from './biz/index'

export default [
    ...bizRouters,
    {
        path: '/index',
        name: 'home',
        component: Layout,
        redirect: '/index/index',
        children: [{
            path: 'index',
            name: 'index',
            component: () => import(/* webpackChunkName: "views" */ '@/views/index/index.vue'),
            meta: {
                title: '首页',
                isAuth:false,
                dingConfig:false
            }
        }, {
            path: 'index2',
            name: 'index2',
            component: () => import(/* webpackChunkName: "views" */ '@/views/index/index2.vue'),
            meta: {
                title: '首页',
                isAuth:false,
                dingConfig:false
            }
        },{
            path: 'workspace',
            name: 'workspace',
            component: () => import(/* webpackChunkName: "views" */ '@/views/workspace/index.vue'),
            meta: {
                title: '督学工作',
                isAuth:false,
                dingConfig:false
            }
        }, {
            path: 'notes',
            name: 'notes',
            component: () => import(/* webpackChunkName: "views" */ '@/views/notes/index.vue'),
            meta: {
                title: '督学笔记',
                isAuth:false,
                dingConfig:false
            }
        },{
            path: 'my',
            name: 'my',
            component: () => import(/* webpackChunkName: "views" */ '@/views/my/index.vue'),
            meta: {
                title: '我的',
                isAuth:false,
                dingConfig:false
            }
        }]
    }
]
